export const FETCH_LOCATION_LINKS_LIST = 'LOCATION/FETCH_LOCATION_LINKS_LIST';
export const FETCH_LOCATION_LINKS_LIST_ERROR = 'LOCATION/FETCH_LOCATION_LINKS_LIST_ERROR';
export const CLEAR_FETCH_LOCATION_LINKS_LIST = 'LOCATION/CLEAR_FETCH_LOCATION_LINKS_LIST';

export const APPLY_LOCATION_LINK_DRAG = 'LOCATION/APPLY_LOCATION_LINK_DRAG';
export const APPLY_LOCATION_LINK_DRAG_ERROR = 'LOCATION/APPLY_LOCATION_LINK_DRAG_ERROR';
export const CLEAR_LOCATION_LINK_DRAG = 'LOCATION/CLEAR_LOCATION_LINK_DRAG';

export const CREATE_LOCATION_LINK_SUCCESS = 'LOCATION/CREATE_LOCATION_LINK_SUCCESS';
export const CREATE_LOCATION_LINK_ERROR = 'LOCATION/CREATE_LOCATION_LINK_ERROR';
export const CLEAR_CREATE_LOCATION_LINK = 'LOCATION/CLEAR_CREATE_LOCATION_LINK';

export const PATCH_LOCATION_LINK_SUCCESS = 'LOCATION/PATCH_LOCATION_LINK_SUCCESS';
export const PATCH_LOCATION_LINK_ERROR = 'LOCATION/PATCH_LOCATION_LINK_ERROR';
export const CLEAR_PATCH_LOCATION_LINK = 'LOCATION/CLEAR_PATCH_LOCATION_LINK';

export const DELETE_LOCATION_LINK_SUCCESS = 'LOCATION/DELETE_LOCATION_LINK_SUCCESS';
export const DELETE_LOCATION_LINK_ERROR = 'LOCATION/DELETE_LOCATION_LINK_ERROR';
export const CLEAR_DELETE_LOCATION_LINK = 'LOCATION/CLEAR_DELETE_LOCATION_LINK';

export const CREATE_LOCATION_MARKER_SUCCESS = 'LOCATION/CREATE_LOCATION_MARKER_SUCCESS';
export const CREATE_LOCATION_MARKER_ERROR = 'LOCATION/CREATE_LOCATION_MARKER_ERROR';
export const CLEAR_CREATE_LOCATION_MARKER = 'LOCATION/CLEAR_CREATE_LOCATION_MARKER';

export const PATCH_LOCATION_MARKER_SUCCESS = 'LOCATION/PATCH_LOCATION_MARKER_SUCCESS';
export const PATCH_LOCATION_MARKER_ERROR = 'LOCATION/PATCH_LOCATION_MARKER_ERROR';
export const CLEAR_PATCH_LOCATION_MARKER = 'LOCATION/CLEAR_PATCH_LOCATION_MARKER';

export const DELETE_LOCATION_MARKER_SUCCESS = 'LOCATION/DELETE_LOCATION_MARKER_SUCCESS';
export const DELETE_LOCATION_MARKER_ERROR = 'LOCATION/DELETE_LOCATION_MARKER_ERROR';
export const CLEAR_DELETE_LOCATION_MARKER = 'LOCATION/CLEAR_DELETE_LOCATION_MARKER';
